module.exports = __webpack_public_path__ + "img/LPTemp3.23c3f029.png";